import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { env } from '../../configs/EnvironmentConfig';

const PROVIDER_CONFIG = {
  clientSideID: env.REACT_APP_LAUNCHDARKLY_CLIENT_SIDE_ID!,
};

const withFeatureFlagsProvider = withLDProvider(PROVIDER_CONFIG);

export default withFeatureFlagsProvider;
